import * as DOMPurify from 'isomorphic-dompurify'

export function sanitize(text: string): string {
    return DOMPurify.sanitize(text)
}
